module.exports = __webpack_public_path__ + "static/media/picture.798c27a8.png";